'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by li on 2016/4/7.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlipCard = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FlipCard, _Component);

  function FlipCard() {
    (0, _classCallCheck3.default)(this, FlipCard);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(FlipCard).apply(this, arguments));
  }

  (0, _createClass3.default)(FlipCard, [{
    key: 'componentClick',
    value: function componentClick() {
      var _props = this.props;
      var onFrontClick = _props.onFrontClick;
      var goeasyTag = _props.goeasyTag;

      if (onFrontClick !== null) {
        onFrontClick(goeasyTag);
      } else {
        console.log('空');
      }
    }
  }, {
    key: 'componentMouseOver',
    value: function componentMouseOver() {
      var _props2 = this.props;
      var onFrontMouseOver = _props2.onFrontMouseOver;
      var goeasyTag = _props2.goeasyTag;

      if (onFrontMouseOver) {
        onFrontMouseOver(goeasyTag);
      } else {
        console.log('空');
      }
    }
  }, {
    key: 'componentMouseLeave',
    value: function componentMouseLeave() {
      var _props3 = this.props;
      var componentMouseLeave = _props3.componentMouseLeave;
      var goeasyTag = _props3.goeasyTag;

      if (componentMouseLeave) {
        componentMouseLeave(goeasyTag);
      } else {
        console.log('空');
      }
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var flipped = this.props.flipped;

      var styles = require('./FlipCard.scss');
      return _react2.default.Children.map(this.props.children, function (child, index) {
        var firstClassName = ''; // flipped === true ? styles.fan : '';
        var secondClassName = '';
        if (flipped === true) {
          firstClassName = styles.fan;
          secondClassName = styles.chu;
        } else if (flipped === false) {
          firstClassName = styles.chu;
          secondClassName = styles.fan;
        }

        var newClassName = index === 0 ? firstClassName : secondClassName;

        var result = _react2.default.cloneElement(child, {
          className: child.props.className + ' ' + newClassName
        });
        return result;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!Array.isArray(this.props.children)) {
        return _react2.default.createElement(
          'div',
          null,
          this.props.children
        );
      }
      return _react2.default.createElement(
        'div',
        { onClick: this.componentClick.bind(this), onMouseOver: this.componentMouseOver.bind(this),
          onMouseLeave: this.componentMouseLeave.bind(this) },
        this.renderChildren()
      );
    }
  }]);
  return FlipCard;
}(_react.Component), _class.propTypes = {
  onFrontClick: _react.PropTypes.func,
  onFrontMouseOver: _react.PropTypes.func,
  componentMouseLeave: _react.PropTypes.func,
  goeasyTag: _react.PropTypes.string,
  flipped: _react.PropTypes.bool,
  children: function children(props, propName, componentName) {
    var prop = props[propName];

    if (_react2.default.Children.count(prop) !== 2) {
      return new Error('`' + componentName + '` ' + 'should contain exactly two children. ' + 'The first child represents the front of the card. ' + 'The second child represents the back of the card.');
    }
  }
}, _temp);
exports.default = FlipCard;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FlipCard/FlipCard.js
 ** module id = 308
 ** module chunks = 0
 **/